import { render, staticRenderFns } from "./SortingActivityLog.vue?vue&type=template&id=1d73dcfa&scoped=true&"
import script from "./SortingActivityLog.vue?vue&type=script&lang=js&"
export * from "./SortingActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d73dcfa",
  null
  
)

export default component.exports